import React from "react";
import CaseHit from "./CaseHit";
import CustomerHit from "./CustomerHit";
import { HitProperties } from "./hitType";

export default function MainSearchHit(hitProperties: HitProperties) {
  return hitProperties.hit.product === "Customer" ?
    <CustomerHit {...hitProperties} /> :
    <CaseHit {...hitProperties} />;
}